var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCtaArrow = function SvgCtaArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5h14.17l-3.58-3.59L12 0l6 6-6 6-1.41-1.41L14.17 7H0z"
  })));
};
export default SvgCtaArrow;